// UI string dictionary. Content (questions/blog) is translated server-side via ?lang.
export const translations = {
  en: {
    "nav.home": "Home",
    "nav.knowledge": "Knowledge Test",
    "nav.checklist": "Correct NLP Checklist",
    "nav.leaderboards": "Leaderboards",
    "nav.blog": "Blog",
    "nav.admin": "Admin",
    "nav.login": "Login",
    "nav.logout": "Logout",
    "brand.tagline": "Being realistic about NLP",
    "title.suffix": "truthaboutnlp.org",
    "title.home": "truthaboutnlp.org — Being realistic about NLP",
    "title.knowledge": "NLP Knowledge Test · truthaboutnlp.org",
    "title.checklist": "Correct NLP Checklist · truthaboutnlp.org",
    "title.leaderboards": "Leaderboards · truthaboutnlp.org",
    "title.blog": "Blog · truthaboutnlp.org",
    "title.login": "Login · truthaboutnlp.org",
    "title.admin": "Admin · truthaboutnlp.org",
    "footer.assess": "Assess",
    "footer.learn": "Learn",
    "footer.knowledge": "NLP Knowledge Test",
    "footer.checklist": "Correct NLP Checklist",
    "footer.leaderboards": "Top 100 Leaderboards",
    "footer.blog": "The Blog",
    "footer.createAccount": "Create an account",
    "footer.about": "Separating empirical method from marketing myth in Neuro-Linguistic Programming.",
    "footer.initiative": "The truth about NLP is an initiative of TIOUW.com BV, Binderij 7L, 1185 ZH, Amstelveen, the Netherlands.",
    "footer.copyright": "truthaboutnlp.org — the truth about NLP.",

    "nav.wiki": "Wiki",
    "title.wiki": "ABC-NLP Wiki · truthaboutnlp.org",
    "wiki.kicker": "ABC-NLP Wiki",
    "wiki.title": "The ABC-NLP Wiki",
    "wiki.subtitle": "A structured reference on behaviour, experience, language and change — ten knowledge domains, members only.",
    "wiki.membersOnly": "Members only",
    "wiki.domainsLabel": "Ten knowledge domains",
    "wiki.entries": "entries",
    "wiki.readArticle": "Read",
    "wiki.overview": "Overview",
    "wiki.inThisDomain": "In this domain",
    "wiki.backToWiki": "All domains",
    "wiki.prev": "Previous",
    "wiki.next": "Next",
    "wiki.loading": "Loading the Wiki…",
    "wiki.notFound": "Article not found.",
    "wiki.openDomain": "Open domain",

    "wiki.paywall.badge": "Members-only content",
    "wiki.paywall.title": "Unlock the ABC-NLP Wiki",
    "wiki.paywall.subtitle": "Get lifetime access to all 10 knowledge domains and 80 in-depth articles for a one-time payment of €10.",
    "wiki.paywall.price": "€10",
    "wiki.paywall.priceNote": "one-time · lifetime access",
    "wiki.paywall.cta": "Unlock for €10",
    "wiki.paywall.processing": "Redirecting to secure checkout…",
    "wiki.paywall.feature1": "All 10 knowledge domains",
    "wiki.paywall.feature2": "80 in-depth articles, in English & Dutch",
    "wiki.paywall.feature3": "Lifetime access — pay once, yours forever",
    "wiki.paywall.secure": "Secure payment powered by Stripe",
    "wiki.accessActive": "Wiki access: active",
    "payment.verifying": "Confirming your payment…",
    "payment.successTitle": "Payment successful",
    "payment.successBody": "Your ABC-NLP Wiki access is now active. Enjoy the full library.",
    "payment.goToWiki": "Open the Wiki",
    "payment.failedTitle": "Payment not completed",
    "payment.failedBody": "We couldn't confirm your payment. If you were charged, please contact us and we'll sort it out.",
    "payment.cancelTitle": "Payment cancelled",
    "payment.cancelBody": "No charge was made. You can unlock the Wiki whenever you're ready.",
    "payment.backToWiki": "Back to the Wiki",
    "payment.timeout": "This is taking longer than expected. Your access will activate automatically once the payment clears.",

    "home.badge": "Learning and contributing at the same time",
    "home.h1a": "The truth about ",
    "home.h1b": ", separated from the nonsense sold as \u201cNLP\u201d.",
    "home.intro": "Test what you actually know about Neuro-Linguistic Programming and check whether an NLP trainer actually teaches NLP correctly. Two rigorous questionnaires. Two public leaderboards. No belief required.",
    "home.ctaKnowledge": "Take the Knowledge Test",
    "home.ctaScore": "Score a Trainer",
    "home.liveIndex": "Live index",
    "home.stat.knowledge": "Knowledge tests",
    "home.stat.trainers": "Trainers rated",
    "home.stat.checklist": "Checklist runs",
    "home.stat.members": "Members",
    "home.quick.leaderboards": "Top 100 leaderboards",
    "home.quick.leaderboardsDesc": "Best scores & most reliable trainers",
    "home.quick.blog": "Read the evidence",
    "home.quick.blogDesc": "Fact-checks & technique breakdowns",
    "home.matrix.kicker": "The comparison matrix",
    "home.matrix.title": "Myth vs. what actually holds up",
    "home.launch.knowledgeTag": "100 questions",
    "home.launch.knowledgeTitle": "NLP Knowledge Test",
    "home.launch.knowledgeDesc": "How much do you really know? Practitioners score ~25, Trainers ~55, Master Trainers ~80. Register to claim your rank.",
    "home.launch.knowledgeCta": "Start the test",
    "home.launch.checklistTag": "42 red flags",
    "home.launch.checklistTitle": "Correct NLP Checklist",
    "home.launch.checklistDesc": "Evaluate any NLP trainer against 42 warning signs. Watch the reliability meter move in real time and add them to the leaderboard.",
    "home.launch.checklistCta": "Evaluate a trainer",
    "home.blog.kicker": "From the blog",
    "home.blog.title": "Recent evidence & analysis",
    "home.blog.all": "All articles",

    "myth.1.myth": "NLP is a proven science",
    "myth.1.truth": "NLP is a modelling discipline, not a science. It is powerful, but it is not psychology in a lab coat.",
    "myth.2.myth": "You must believe in it for it to work",
    "myth.2.truth": "If a technique only works once you believe, that is faith — not method. Real NLP can be tested.",
    "myth.3.myth": "Anyone can call themselves a Master Trainer",
    "myth.3.truth": "Genuine trainers hold a license. 'Trust the process' is not a certification.",
    "myth.4.myth": "NLP therapy fixes everything",
    "myth.4.truth": "NLP is not therapy, and claims that it 'works for everyone or solves anything' are a red flag.",

    "quiz.loading": "Loading test…",
    "knowledge.kicker": "Assessment · 100 questions",
    "quiz.questionOf": "Question {n} of {t}",
    "quiz.answered": "{n} answered",
    "quiz.previous": "Previous",
    "quiz.next": "Next",
    "quiz.submit": "Submit test",
    "quiz.scoring": "Scoring…",
    "quiz.nameOptional": "Your name (optional)",
    "quiz.loginHint": "Log in or register",
    "quiz.loginHintTail": " to appear on the Top 100 leaderboard.",
    "knowledge.tier.master": "Master Trainer level",
    "knowledge.tier.trainer": "Trainer level",
    "knowledge.tier.practitioner": "Practitioner level",
    "knowledge.tier.beginner": "Beginner",
    "knowledge.scored": "You scored {s} out of {t}",
    "knowledge.recorded": "Your score has been recorded on the Top 100 Knowledge leaderboard.",
    "knowledge.recordedAnon": "Log in or register to have your score counted on the Top 100 leaderboard.",
    "knowledge.viewLeaderboard": "View leaderboard",
    "knowledge.retake": "Retake test",
    "common.register": "Register",

    "checklist.kicker": "Trainer evaluation · 42 red flags",
    "checklist.trainerName": "Trainer name",
    "checklist.trainerHint": "— type here to add them to the leaderboard",
    "checklist.trainerPlaceholder": "Type a trainer's name, e.g. Jane Doe / Acme NLP Institute",
    "checklist.opt.yes": "Yes",
    "checklist.opt.no": "No",
    "checklist.opt.unknown": "Unknown",
    "checklist.meter": "Reliability meter",
    "checklist.meterLabel": "Probability this trainer teaches NLP correctly",
    "checklist.answeredOf": "{n} / {t} answered",
    "checklist.rangeNote": "Values range from a minimum of 1% to a maximum of 99% — we never claim absolute certainty, so there is always a margin of doubt.",
    "checklist.info": "Each answer that matches what a genuine trainer would give raises the score. Fewer red flags → higher reliability.",
    "checklist.submit": "Submit evaluation",
    "checklist.calculating": "Calculating…",
    "checklist.loginHint": "Log in",
    "checklist.loginHintTail": " to add this trainer to the Top 100.",
    "checklist.verdict.good": "Likely a genuine, competent trainer",
    "checklist.verdict.mixed": "Mixed signals — proceed with caution",
    "checklist.verdict.bad": "Low probability of a Correct NLP trainer",
    "checklist.thisTrainer": "This trainer",
    "checklist.scores": "scores",
    "checklist.resultLine": "Estimated probability of teaching NLP correctly: {c}% · Incorrect-NLP probability: {f}%.",
    "checklist.savedToLb": " This result has been added to the Top 100 Trainers leaderboard.",
    "checklist.addName": " Add a trainer name next time to place them on the leaderboard.",
    "checklist.loginToLb": " Log in and add a trainer name to place them on the leaderboard.",
    "checklist.trainerLeaderboard": "Trainer leaderboard",
    "checklist.evaluateAnother": "Evaluate another",

    "lb.kicker": "Public rankings",
    "lb.title": "The Top 100",
    "lb.subtitle": "Two leaderboards: the highest scorers on the NLP Knowledge Test, and the trainers most likely to be teaching NLP correctly.",
    "lb.tab.trainers": "Trainers",
    "lb.tab.knowledge": "Knowledge Test",
    "lb.trainersTitle": "The Top 100 NLP Trainers Most Likely Teaching NLP Correctly",
    "lb.knowledgeTitle": "The Top 100 Most Knowledgeable People on NLP",
    "lb.rangeNote": "Values range from a minimum of 1% to a maximum of 99% — we never claim absolute certainty, so there is always a margin of doubt.",
    "lb.zonesTitle": "Knowledge levels",
    "lb.level.masterTrainer": "NLP Master Trainer level",
    "lb.level.trainer": "NLP Trainer level",
    "lb.level.masterPractitioner": "NLP Master Practitioner level",
    "lb.level.practitioner": "NLP Practitioner level",
    "lb.level.novice": "NLP Novice level",
    "lb.emptyKnowledge": "No ranked scores yet. Register and take the Knowledge Test to claim #1.",
    "lb.emptyKnowledgeCta": "Take the test",
    "lb.emptyTrainers": "No trainers rated yet. Run one through the Correct NLP Checklist.",
    "lb.emptyTrainersCta": "Evaluate a trainer",
    "lb.loading": "Loading rankings…",
    "lb.correct": "correct",
    "lb.ratedBy": "rated by {r}",

    "blog.kicker": "The blog",
    "blog.title": "The truth, documented",
    "blog.subtitle": "Fact-checks, technique breakdowns, and honest analysis of Neuro-Linguistic Programming.",
    "blog.search": "Search articles…",
    "blog.loading": "Loading articles…",
    "blog.none": "No articles found.",
    "blog.featured": "Featured",
    "blog.read": "Read article →",
    "blog.allArticles": "All articles",
    "blog.notFound": "Article not found",
    "blog.backToBlog": "← Back to the blog",

    "auth.tagline": "Being realistic about NLP",
    "auth.login": "Log in",
    "auth.register": "Register",
    "auth.welcomeBack": "Welcome back",
    "auth.create": "Create your account",
    "auth.loginSub": "Log in to track your scores.",
    "auth.registerSub": "Register to appear on the leaderboards.",
    "auth.displayName": "Display name",
    "auth.displayNamePh": "How you appear on leaderboards",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.wait": "Please wait…",
    "auth.loginBtn": "Log in",
    "auth.createBtn": "Create account",
    "auth.anonHint": "You can also take both questionnaires anonymously —",
    "auth.anonHintLink": "start here",
    "auth.sideTitle": "Join the effort to separate method from myth.",
    "auth.sideDesc": "An account lets you claim your rank on the Top 100 Knowledge leaderboard and add trainers to the reliability index.",
    "auth.verifying": "Verifying access…",

    "expl.whyTitle": "Want to know why?",
    "expl.whyDesc": "Read the explanation behind every correct answer — why it is right and the others are not.",
    "expl.readBtn": "Read the explanations",
    "expl.freeAccount": "Free account required — takes a few seconds.",
    "expl.stats": "This test includes {l} lessons and {v} videos.",
    "expl.videoLabel": "Watch the explanation",
    "expl.answersOnlyTitle": "Your answers",
    "expl.answersOnlyDesc": "You have completed this test. Here are the correct answers and explanations.",
    "expl.knowledgeDone": "You have already taken the Knowledge Test — it can only be taken once. Below are all the answers.",
    "expl.addTrainerFirst": "Add a trainer with the checklist to unlock the answers.",
    "checklist.duplicateTrainer": "This trainer is already in the list. Enter a different trainer to continue.",
    "expl.gateRegisterTitle": "Create a free account to unlock the explanations",
    "expl.gateLoginTitle": "Log in to unlock the explanations",
    "expl.gateSub": "It only takes a moment — then the explanations appear right here.",
    "expl.createAndView": "Create account & view explanations",
    "expl.loginAndView": "Log in & view explanations",
    "expl.haveAccount": "Already have an account?",
    "expl.newHere": "New here?",
    "expl.title": "Explanations",
    "expl.loading": "Loading explanations…",
    "expl.correct": "Correct",
    "expl.none": "No explanation has been added for this question yet.",
    "expl.disagree": "Disagree with an answer?",
    "expl.disagreeLink": "Read more on the blog",
    "expl.imageCaption": "This chart shows how the surveyed NLP trainers actually answered this question. The green bar marks the correct answer.",
    "comments.title": "Questions & comments",
    "comments.none": "No comments yet — be the first to ask a question.",
    "comments.placeholder": "Ask a question or share a comment…",
    "comments.replyPlaceholder": "Write a reply…",
    "comments.post": "Post",
    "comments.posting": "Posting…",
    "comments.reply": "Reply",
    "comments.cancel": "Cancel",
    "comments.delete": "Delete",
    "comments.deleteConfirm": "Delete this comment and all of its replies?",
    "comments.pendingNotice": "Thanks! Your comment was submitted and will appear once an admin approves it.",
    "comments.adminBadge": "Admin",
    "comments.showThread": "Show discussion",
    "comments.hideThread": "Hide discussion",
    "expl.perksTitle": "Free registration unlocks:",
    "expl.perkExplain": "Full explanations",
    "expl.perkExplainDesc": "Why each answer is right — plus a video.",
    "expl.perkChart": "Answer distribution",
    "expl.perkChartDesc": "See which answers NLP trainers picked most.",
    "expl.perkDiscuss": "Join the discussion",
    "expl.perkDiscussDesc": "Ask questions and comment on every answer.",
  },
  nl: {
    "nav.home": "Home",
    "nav.knowledge": "Kennistest",
    "nav.checklist": "Correcte NLP-checklist",
    "nav.leaderboards": "Ranglijsten",
    "nav.blog": "Blog",
    "nav.admin": "Beheer",
    "nav.login": "Inloggen",
    "nav.logout": "Uitloggen",
    "brand.tagline": "Realistisch zijn over NLP",
    "title.suffix": "truthaboutnlp.org",
    "title.home": "truthaboutnlp.org — Realistisch zijn over NLP",
    "title.knowledge": "NLP Kennistest · truthaboutnlp.org",
    "title.checklist": "Correcte NLP-checklist · truthaboutnlp.org",
    "title.leaderboards": "Ranglijsten · truthaboutnlp.org",
    "title.blog": "Blog · truthaboutnlp.org",
    "title.login": "Inloggen · truthaboutnlp.org",
    "title.admin": "Beheer · truthaboutnlp.org",
    "footer.assess": "Beoordelen",
    "footer.learn": "Leren",
    "footer.knowledge": "NLP-kennistest",
    "footer.checklist": "Correcte NLP-checklist",
    "footer.leaderboards": "Top 100-ranglijsten",
    "footer.blog": "De blog",
    "footer.createAccount": "Account aanmaken",
    "footer.about": "We scheiden de empirische methode van de marketingmythe in Neuro-Linguïstisch Programmeren.",
    "footer.initiative": "De waarheid over NLP is een initiatief van TIOUW.com BV, Binderij 7L, 1185 ZH, Amstelveen, Nederland.",
    "footer.copyright": "truthaboutnlp.org — de waarheid over NLP.",

    "nav.wiki": "Wiki",
    "title.wiki": "ABC-NLP Wiki · truthaboutnlp.org",
    "wiki.kicker": "ABC-NLP Wiki",
    "wiki.title": "De ABC-NLP Wiki",
    "wiki.subtitle": "Een gestructureerde naslag over gedrag, ervaring, taal en verandering — tien kennisdomeinen, alleen voor leden.",
    "wiki.membersOnly": "Alleen voor leden",
    "wiki.domainsLabel": "Tien kennisdomeinen",
    "wiki.entries": "onderwerpen",
    "wiki.readArticle": "Lezen",
    "wiki.overview": "Overzicht",
    "wiki.inThisDomain": "In dit domein",
    "wiki.backToWiki": "Alle domeinen",
    "wiki.prev": "Vorige",
    "wiki.next": "Volgende",
    "wiki.loading": "Wiki laden…",
    "wiki.notFound": "Onderwerp niet gevonden.",
    "wiki.openDomain": "Open domein",

    "wiki.paywall.badge": "Alleen voor leden",
    "wiki.paywall.title": "Ontgrendel de ABC-NLP Wiki",
    "wiki.paywall.subtitle": "Krijg levenslang toegang tot alle 10 kennisdomeinen en 80 uitgebreide artikelen voor een eenmalige betaling van €10.",
    "wiki.paywall.price": "€10",
    "wiki.paywall.priceNote": "eenmalig · levenslange toegang",
    "wiki.paywall.cta": "Ontgrendel voor €10",
    "wiki.paywall.processing": "Doorsturen naar de beveiligde betaling…",
    "wiki.paywall.feature1": "Alle 10 kennisdomeinen",
    "wiki.paywall.feature2": "80 uitgebreide artikelen, in het Engels & Nederlands",
    "wiki.paywall.feature3": "Levenslange toegang — eenmalig betalen, voor altijd van jou",
    "wiki.paywall.secure": "Veilig betalen via Stripe",
    "wiki.accessActive": "Wiki-toegang: actief",
    "payment.verifying": "Je betaling wordt bevestigd…",
    "payment.successTitle": "Betaling geslaagd",
    "payment.successBody": "Je toegang tot de ABC-NLP Wiki is nu actief. Veel plezier met de volledige bibliotheek.",
    "payment.goToWiki": "Open de Wiki",
    "payment.failedTitle": "Betaling niet voltooid",
    "payment.failedBody": "We konden je betaling niet bevestigen. Als er is afgeschreven, neem dan contact met ons op en we lossen het op.",
    "payment.cancelTitle": "Betaling geannuleerd",
    "payment.cancelBody": "Er is niets afgeschreven. Je kunt de Wiki ontgrendelen wanneer je er klaar voor bent.",
    "payment.backToWiki": "Terug naar de Wiki",
    "payment.timeout": "Dit duurt langer dan verwacht. Je toegang wordt automatisch geactiveerd zodra de betaling is verwerkt.",

    "home.badge": "Tegelijk leren en bijdragen",
    "home.h1a": "De waarheid over ",
    "home.h1b": ", gescheiden van de onzin die als \u201cNLP\u201d wordt verkocht.",
    "home.intro": "Test wat je echt weet over Neuro-Linguïstisch Programmeren en controleer of een NLP-trainer NLP daadwerkelijk correct onderwijst. Twee grondige vragenlijsten. Twee openbare ranglijsten. Geen geloof vereist.",
    "home.ctaKnowledge": "Doe de kennistest",
    "home.ctaScore": "Beoordeel een trainer",
    "home.liveIndex": "Live-index",
    "home.stat.knowledge": "Kennistests",
    "home.stat.trainers": "Beoordeelde trainers",
    "home.stat.checklist": "Checklist-runs",
    "home.stat.members": "Leden",
    "home.quick.leaderboards": "Top 100-ranglijsten",
    "home.quick.leaderboardsDesc": "Beste scores & meest betrouwbare trainers",
    "home.quick.blog": "Lees het bewijs",
    "home.quick.blogDesc": "Feitenchecks & techniekanalyses",
    "home.matrix.kicker": "De vergelijkingsmatrix",
    "home.matrix.title": "Mythe versus wat werkelijk standhoudt",
    "home.launch.knowledgeTag": "100 vragen",
    "home.launch.knowledgeTitle": "NLP-kennistest",
    "home.launch.knowledgeDesc": "Hoeveel weet je echt? Practitioners scoren ~25, Trainers ~55, Master Trainers ~80. Registreer om je positie te claimen.",
    "home.launch.knowledgeCta": "Start de test",
    "home.launch.checklistTag": "42 rode vlaggen",
    "home.launch.checklistTitle": "Correcte NLP-checklist",
    "home.launch.checklistDesc": "Beoordeel elke NLP-trainer aan de hand van 42 waarschuwingssignalen. Zie de betrouwbaarheidsmeter live bewegen en voeg ze toe aan de ranglijst.",
    "home.launch.checklistCta": "Beoordeel een trainer",
    "home.blog.kicker": "Van de blog",
    "home.blog.title": "Recent bewijs & analyse",
    "home.blog.all": "Alle artikelen",

    "myth.1.myth": "NLP is een bewezen wetenschap",
    "myth.1.truth": "NLP is een modelleringsdiscipline, geen wetenschap. Het is krachtig, maar het is geen psychologie in een witte jas.",
    "myth.2.myth": "Je moet erin geloven om het te laten werken",
    "myth.2.truth": "Als een techniek pas werkt zodra je erin gelooft, is dat geloof — geen methode. Echte NLP is toetsbaar.",
    "myth.3.myth": "Iedereen kan zich Master Trainer noemen",
    "myth.3.truth": "Echte trainers hebben een licentie. 'Vertrouw op het proces' is geen certificering.",
    "myth.4.myth": "NLP-therapie lost alles op",
    "myth.4.truth": "NLP is geen therapie, en beweringen dat het 'voor iedereen werkt of alles oplost' zijn een rode vlag.",

    "quiz.loading": "Test laden…",
    "knowledge.kicker": "Beoordeling · 100 vragen",
    "quiz.questionOf": "Vraag {n} van {t}",
    "quiz.answered": "{n} beantwoord",
    "quiz.previous": "Vorige",
    "quiz.next": "Volgende",
    "quiz.submit": "Test indienen",
    "quiz.scoring": "Berekenen…",
    "quiz.nameOptional": "Je naam (optioneel)",
    "quiz.loginHint": "Log in of registreer",
    "quiz.loginHintTail": " om op de Top 100-ranglijst te verschijnen.",
    "knowledge.tier.master": "Master Trainer-niveau",
    "knowledge.tier.trainer": "Trainer-niveau",
    "knowledge.tier.practitioner": "Practitioner-niveau",
    "knowledge.tier.beginner": "Beginner",
    "knowledge.scored": "Je scoorde {s} van de {t}",
    "knowledge.recorded": "Je score is vastgelegd op de Top 100-kennisranglijst.",
    "knowledge.recordedAnon": "Log in of registreer om je score mee te laten tellen op de Top 100-ranglijst.",
    "knowledge.viewLeaderboard": "Bekijk ranglijst",
    "knowledge.retake": "Test opnieuw doen",
    "common.register": "Registreren",

    "checklist.kicker": "Trainerbeoordeling · 42 rode vlaggen",
    "checklist.trainerName": "Naam trainer",
    "checklist.trainerHint": "— typ hier om ze aan de ranglijst toe te voegen",
    "checklist.trainerPlaceholder": "Typ de naam van een trainer, bijv. Jan Jansen / Acme NLP-instituut",
    "checklist.opt.yes": "Ja",
    "checklist.opt.no": "Nee",
    "checklist.opt.unknown": "Onbekend",
    "checklist.meter": "Betrouwbaarheidsmeter",
    "checklist.meterLabel": "Waarschijnlijkheid dat deze trainer NLP correct onderwijst",
    "checklist.answeredOf": "{n} / {t} beantwoord",
    "checklist.rangeNote": "Waarden variëren van minimaal 1% tot maximaal 99% — we claimen nooit absolute zekerheid, dus er blijft altijd een marge van twijfel.",
    "checklist.info": "Elk antwoord dat overeenkomt met wat een echte trainer zou geven, verhoogt de score. Minder rode vlaggen → hogere betrouwbaarheid.",
    "checklist.submit": "Beoordeling indienen",
    "checklist.calculating": "Berekenen…",
    "checklist.loginHint": "Log in",
    "checklist.loginHintTail": " om deze trainer aan de Top 100 toe te voegen.",
    "checklist.verdict.good": "Waarschijnlijk een echte, competente trainer",
    "checklist.verdict.mixed": "Gemengde signalen — wees voorzichtig",
    "checklist.verdict.bad": "Lage waarschijnlijkheid van een correcte NLP-trainer",
    "checklist.thisTrainer": "Deze trainer",
    "checklist.scores": "scoort",
    "checklist.resultLine": "Geschatte waarschijnlijkheid dat NLP correct wordt onderwezen: {c}% · Waarschijnlijkheid van incorrecte NLP: {f}%.",
    "checklist.savedToLb": " Dit resultaat is toegevoegd aan de Top 100-trainersranglijst.",
    "checklist.addName": " Voeg volgende keer een trainernaam toe om ze op de ranglijst te plaatsen.",
    "checklist.loginToLb": " Log in en voeg een trainernaam toe om ze op de ranglijst te plaatsen.",
    "checklist.trainerLeaderboard": "Trainersranglijst",
    "checklist.evaluateAnother": "Beoordeel een andere",

    "lb.kicker": "Openbare ranglijsten",
    "lb.title": "De Top 100",
    "lb.subtitle": "Twee ranglijsten: de hoogste scoorders op de NLP-kennistest, en de trainers die het meest waarschijnlijk NLP correct onderwijzen.",
    "lb.tab.trainers": "Trainers",
    "lb.tab.knowledge": "Kennistest",
    "lb.trainersTitle": "De Top 100 NLP-trainers die het meest waarschijnlijk NLP correct onderwijzen",
    "lb.knowledgeTitle": "De Top 100 mensen met de meeste kennis over NLP",
    "lb.rangeNote": "Waarden variëren van minimaal 1% tot maximaal 99% — we claimen nooit absolute zekerheid, dus er blijft altijd een marge van twijfel.",
    "lb.zonesTitle": "Kennisniveaus",
    "lb.level.masterTrainer": "NLP Master Trainer niveau",
    "lb.level.trainer": "NLP Trainer niveau",
    "lb.level.masterPractitioner": "NLP Master Practitioner niveau",
    "lb.level.practitioner": "NLP Practitioner niveau",
    "lb.level.novice": "NLP-leek niveau",
    "lb.emptyKnowledge": "Nog geen scores op de ranglijst. Registreer en doe de kennistest om #1 te worden.",
    "lb.emptyKnowledgeCta": "Doe de test",
    "lb.emptyTrainers": "Nog geen trainers beoordeeld. Beoordeel er een via de Correcte NLP-checklist.",
    "lb.emptyTrainersCta": "Beoordeel een trainer",
    "lb.loading": "Ranglijsten laden…",
    "lb.correct": "correct",
    "lb.ratedBy": "beoordeeld door {r}",

    "blog.kicker": "De blog",
    "blog.title": "De waarheid, gedocumenteerd",
    "blog.subtitle": "Feitenchecks, techniekanalyses en eerlijke analyse van Neuro-Linguïstisch Programmeren.",
    "blog.search": "Artikelen zoeken…",
    "blog.loading": "Artikelen laden…",
    "blog.none": "Geen artikelen gevonden.",
    "blog.featured": "Uitgelicht",
    "blog.read": "Lees artikel →",
    "blog.allArticles": "Alle artikelen",
    "blog.notFound": "Artikel niet gevonden",
    "blog.backToBlog": "← Terug naar de blog",

    "auth.tagline": "Realistisch zijn over NLP",
    "auth.login": "Inloggen",
    "auth.register": "Registreren",
    "auth.welcomeBack": "Welkom terug",
    "auth.create": "Maak je account aan",
    "auth.loginSub": "Log in om je scores bij te houden.",
    "auth.registerSub": "Registreer om op de ranglijsten te verschijnen.",
    "auth.displayName": "Weergavenaam",
    "auth.displayNamePh": "Hoe je op ranglijsten verschijnt",
    "auth.email": "E-mail",
    "auth.password": "Wachtwoord",
    "auth.wait": "Even geduld…",
    "auth.loginBtn": "Inloggen",
    "auth.createBtn": "Account aanmaken",
    "auth.anonHint": "Je kunt beide vragenlijsten ook anoniem invullen —",
    "auth.anonHintLink": "begin hier",
    "auth.sideTitle": "Doe mee om methode van mythe te scheiden.",
    "auth.sideDesc": "Met een account claim je je positie op de Top 100-kennisranglijst en voeg je trainers toe aan de betrouwbaarheidsindex.",
    "auth.verifying": "Toegang verifiëren…",

    "expl.whyTitle": "Wil je weten waarom?",
    "expl.whyDesc": "Lees de uitleg achter elk juist antwoord — waarom het klopt en de andere niet.",
    "expl.readBtn": "Lees de uitleg",
    "expl.freeAccount": "Gratis account vereist — kost een paar seconden.",
    "expl.stats": "Deze test bevat {l} lessen en {v} video's.",
    "expl.videoLabel": "Bekijk de uitleg",
    "expl.answersOnlyTitle": "Jouw antwoorden",
    "expl.answersOnlyDesc": "Je hebt deze test voltooid. Hier zijn de juiste antwoorden en uitleg.",
    "expl.knowledgeDone": "Je hebt de kennistest al gedaan — die kan maar één keer worden gemaakt. Hieronder staan alle antwoorden.",
    "expl.addTrainerFirst": "Voeg een trainer toe met de checklist om de antwoorden te ontgrendelen.",
    "checklist.duplicateTrainer": "Deze trainer staat al in de lijst. Voer een andere trainer in om verder te gaan.",
    "expl.gateRegisterTitle": "Maak een gratis account aan om de uitleg te ontgrendelen",
    "expl.gateLoginTitle": "Log in om de uitleg te ontgrendelen",
    "expl.gateSub": "Het kost maar even — daarna verschijnt de uitleg hier direct.",
    "expl.createAndView": "Account aanmaken & uitleg bekijken",
    "expl.loginAndView": "Inloggen & uitleg bekijken",
    "expl.haveAccount": "Heb je al een account?",
    "expl.newHere": "Nieuw hier?",
    "expl.title": "Uitleg",
    "expl.loading": "Uitleg laden…",
    "expl.correct": "Correct",
    "expl.none": "Voor deze vraag is nog geen uitleg toegevoegd.",
    "expl.disagree": "Ben je het niet eens met een antwoord?",
    "expl.disagreeLink": "Lees meer op de blog",
    "expl.imageCaption": "Deze grafiek toont hoe de ondervraagde NLP-trainers deze vraag daadwerkelijk beantwoordden. Het groene balkje markeert het juiste antwoord.",
    "comments.title": "Vragen & reacties",
    "comments.none": "Nog geen reacties — stel als eerste een vraag.",
    "comments.placeholder": "Stel een vraag of plaats een reactie…",
    "comments.replyPlaceholder": "Schrijf een antwoord…",
    "comments.post": "Plaatsen",
    "comments.posting": "Bezig…",
    "comments.reply": "Reageren",
    "comments.cancel": "Annuleren",
    "comments.delete": "Verwijderen",
    "comments.deleteConfirm": "Deze reactie en alle antwoorden erop verwijderen?",
    "comments.pendingNotice": "Bedankt! Je reactie is verzonden en verschijnt zodra een admin deze goedkeurt.",
    "comments.adminBadge": "Admin",
    "comments.showThread": "Toon discussie",
    "comments.hideThread": "Verberg discussie",
    "expl.perksTitle": "Gratis registreren geeft je toegang tot:",
    "expl.perkExplain": "Volledige uitleg",
    "expl.perkExplainDesc": "Waarom elk antwoord juist is — inclusief video.",
    "expl.perkChart": "Antwoordverdeling",
    "expl.perkChartDesc": "Zie welke antwoorden NLP-trainers het vaakst kozen.",
    "expl.perkDiscuss": "Praat mee",
    "expl.perkDiscussDesc": "Stel vragen en reageer op elk antwoord.",
  },
};
